module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAMAAADNlS1EAAAAPFBMVEUAAACDPCiEPSqEPSmEPSqDPSmHQCiAQCiAQCSCPimEPCiDQCyFPCuDPiqEPSmDPSmEPiqDPCiDQCmDPSneD1PDAAAAE3RSTlMAQGDfn+8gIBCPcEAwz79Qz4BQoFUq+QAAAG5JREFUGNPVj0kSgCAMBGOQHUTN//9qUoqgnDzaF4oOM0WgYmKEFyETM5vezXSiUnOeKvp+a+W2FVTS0IcnPl3mobvkSrSAUHhaW1VNWYl8lBE1d6IQWHo07Y8N5YBG8DdSj3KHMK5pAOz0JDk4AA/9Fpt821xEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/icon-password.png
// module id = b7EA
// module chunks = 0